import { render, staticRenderFns } from "./v-chat-bubble-teaser.vue?vue&type=template&id=d473f1c4&scoped=true&"
import script from "./v-chat-bubble-teaser.vue?vue&type=script&lang=js&"
export * from "./v-chat-bubble-teaser.vue?vue&type=script&lang=js&"
import style0 from "./v-chat-bubble-teaser.vue?vue&type=style&index=0&id=d473f1c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d473f1c4",
  null
  
)

export default component.exports